


































import Vue from 'vue'
import { Component, Watch, Prop, Emit } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import AppDialog from '@/components/AppDialog.vue'
import AppTextField from '@/components/AppTextField.vue'
import AppFormCheckbox from '@/components/AppFormCheckbox.vue'
import AppSelector from '@/components/AppSelector.vue'
import AppTextSearch from '@/components/AppTextSearch.vue'
import { SnackType } from '@/interfaces/snack'
import { showErrors, showNotification } from '@/utils/snack'
import SearchCarrier from '@/mixins/search-queries/search-carrier'
import SearchGeneralAgent from '@/mixins/search-queries/search-ga'
import { newCarrierProductCommission, editCarrierProductCommission } from '@/modules/CarrierProduct/gql/carrier-product.gql'

import { CarrierProductCommission } from '@/modules/CarrierProduct/interfaces/carrier-product-commission'

@Component({
  components: {
    AppDialog,
    AppTextField,
    AppFormCheckbox,
    AppSelector,
    AppTextSearch
  }
})
export default class CarrierProductCommissionDialog extends mixins(SearchCarrier, SearchGeneralAgent) {
  @Prop({ type: Boolean }) readonly show!: boolean
  @Prop({ type: String }) readonly title!: string
  @Prop({ type: String }) readonly actionType!: string
  @Prop({ type: String }) readonly commissionType!: string
  @Prop({ type: Object as () => CarrierProductCommission }) readonly commission!: CarrierProductCommission
  @Prop({ type: Number }) readonly productId!: number

  showDialog = false

  disable = false

  commissionInput: {
    [key: string]: any;
  } = {
    commissionName: '',
    commission: '',
    carrier: {},
    ga: {}
  }

  get gaId () {
    const ga = this.candidatesGeneralAgent.find(ga => ga.name === this.commissionInput.gaName)
    return ga ? ga.id : null
  }

  get carrierId () {
    const carrier = this.candidatesCarrier.find(carrier => carrier.name === this.commissionInput.carrierName)
    return carrier ? carrier.id : null
  }

  @Watch('show')
  onShowChanged (val: boolean) {
    this.showDialog = val
    if (val && this.actionType === 'edit') {
      this.editCommissionHandler()
    }
  }

  @Emit('post')
  onPostHandler () {
    // do nothing
  }

  @Emit('success')
  onSuccess () {
    this.disable = false
  }

  editCommissionHandler () {
    const { commissionName, commission, gaName, gaId, carrierName, carrierId } = this.commission
    this.commissionInput.commissionName = commissionName || ''
    this.commissionInput.commission = commission || ''
    this.commissionInput.ga = {
      id: gaId,
      name: gaName
    }
    this.commissionInput.carrier = {
      id: carrierId,
      name: carrierName
    }
  }

  async formConfirm () {
    if (this.actionType === 'new') {
      await this.newCommissionPost()
    } else if (this.actionType === 'edit') {
      await this.editCommissionPost()
    }
  }

  async newCommissionPost () {
    const {
      commission, commissionName,
      ga: {
        id: gaId
      },
      carrier: {
        id: carrierId
      }
    } = this.commissionInput

    const newCarrierValid = (this.$refs.form as Vue & { validate: () => boolean }).validate()
    if (!newCarrierValid) {
      return false
    }

    this.disable = true

    try {
      const res = await this.$apollo.mutate({
        mutation: newCarrierProductCommission,
        variables: {
          productId: Number(this.productId),
          input: {
            carrierId: carrierId ? Number(carrierId) : null,
            gaId: gaId ? Number(gaId) : null,
            commission: commission || '',
            commissionName: commissionName || ''
          }
        }
      })
      showNotification({
        msg: 'Create the new insurance product commission successfully',
        type: SnackType.Success
      })
      this.clearProductInput()
      this.onSuccess()
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async editCommissionPost () {
    const {
      commission, commissionName,
      ga: {
        id: gaId
      },
      carrier: {
        id: carrierId
      }
    } = this.commissionInput

    const newCarrierValid = (this.$refs.form as Vue & { validate: () => boolean }).validate()
    if (!newCarrierValid) {
      return false
    }

    try {
      const res = await this.$apollo.mutate({
        mutation: editCarrierProductCommission,
        variables: {
          commissionId: Number(this.commission.id),
          input: {
            carrierId: carrierId ? Number(carrierId) : null,
            gaId: gaId ? Number(gaId) : null,
            commission: commission || '',
            commissionName: commissionName || ''
          }
        }
      })
      showNotification({
        msg: 'Update the insurance product commission successfully',
        type: SnackType.Success
      })
      this.clearProductInput()
      this.onSuccess()
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  clearProductInput () {
    this.commissionInput = {
      commissionName: '',
      commission: '',
      carrier: {},
      ga: {}
    }
    this.onPostHandler()
  }
}
